import { Box, Link, Paper, Typography } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import { useFoerderProgramm } from 'src/context/FoerderProgrammContext';

// import Schemas
import FoerderRichtlinieSchemas from 'src/lib/paths/foerderrichtlinie_DETAILS_SEITE_Paths.json';
import PersonSchema from 'src/lib/paths/person_FULL_Paths.json';
const FR_P = FoerderRichtlinieSchemas.attributes;
let PERSON_P = PersonSchema.attributes;

/**
 * Die Projektmanager-Text erstmal nur auskommentieren. HA-1667
 * Grund Dafür: Es kann sein, dass HA wieder zum 100MAL die AFO ändert und wieder haben will.
 * Daher erstmal bis zur Abnahme nur auskokmmentieren.
 */

const ProgrammLeitung: FC<{}> = () => {
	const { foerderRichtlinieDetails } = useFoerderProgramm();

	const programmLeitungen = get(foerderRichtlinieDetails, FR_P.Allgemein_Ansprechperson.path, []);

	return (
		<Paper sx={{ p: '2rem' }}>
			<Typography sx={{ fontWeight: 600 }}> Haben Sie Fragen? Wir sind für Sie da:</Typography>
			<ProgrammLeitungen personen={programmLeitungen} />
		</Paper>
	);
};

export default ProgrammLeitung;

const ProgrammLeitungen: FC<{ personen: any[] }> = ({ personen }) => {
	if (isArray(personen) && personen.length > 0) {
		return (
			<>
				{personen.map((ele: any, i: number) => (
					<Box key={i} sx={{ mt: '1rem' }}>
						<Typography sx={{ fontWeight: 600 }}>
							{get(ele, PERSON_P.Personenbezogene_Daten_Vorname.path)} {get(ele, PERSON_P.Personenbezogene_Daten_Nachname.path)}
						</Typography>
						<Typography>{get(ele, PERSON_P.Kontaktdaten_Telefon.path)}</Typography>
						<Typography>
							<Link href={'mailto:' + get(ele, PERSON_P.Kontaktdaten_E_Mail.path)}>{get(ele, PERSON_P.Kontaktdaten_E_Mail.path)}</Link>
						</Typography>
					</Box>
				))}
			</>
		);
	}

	if (typeof personen === 'object') {
		return (
			<Box sx={{ mt: '1rem' }}>
				<Typography sx={{ fontWeight: 600 }}>
					{get(personen, PERSON_P.Personenbezogene_Daten_Vorname.path)} {get(personen, PERSON_P.Personenbezogene_Daten_Nachname.path)}
				</Typography>
				{/* <Typography>
					{get(personen, PERSON_P.Personenbezogene_Daten_Anrede.path, 'Herr') === 'Herr' ? 'Projektmanager' : 'Projektmanagerin'}
				</Typography> */}
				<Typography>{get(personen, PERSON_P.Kontaktdaten_Telefon.path)}</Typography>
				<Typography>
					<Link href={'mailto:' + get(personen, PERSON_P.Kontaktdaten_E_Mail.path)}>{get(personen, PERSON_P.Kontaktdaten_E_Mail.path)}</Link>
				</Typography>
			</Box>
		);
	}

	return <></>;
};
